import { ListItem, OrderedList, Td } from '@chakra-ui/react';
import { StepLine } from '~/monolith-api';
import styles from '../jibTableStyles.module.css';

type ReasonsProps = {
   reasons: StepLine[];
};

export function Reasons({ reasons }: ReasonsProps) {
   return (
      <Td border="var(--chakra-colors-gray-300) solid 1px" width="33%" className={styles.reasons}>
         <OrderedList>
            {reasons.map(
               (reason, index) =>
                  reason.level === 1 && (
                     <ListItem
                        key={index}
                        dangerouslySetInnerHTML={{ __html: reason.text_rendered }}
                     />
                  )
            )}
         </OrderedList>
      </Td>
   );
}
